export default __webpack_public_path__ + "static/default-share-image-a40958ca03c40dcb01344c8c6432c872.png";